import NeedOfferDetailPage from './NeedOfferDetailPage.jsx';
import MybusinessNeedOfferDetailPage from './MybusinessNeedOfferDetailPage.jsx';
import MybusinessNeedOfferPage from './MybusinessNeedOfferPage.jsx';

export {
  NeedOfferDetailPage,
  MybusinessNeedOfferDetailPage,
  MybusinessNeedOfferPage
}


// WEBPACK FOOTER //
// ./pages/need-offer/index.js